import Inventory2Icon from "@mui/icons-material/Inventory2";
import FaceIcon from "@mui/icons-material/Face";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import WarehouseIcon from "@mui/icons-material/Warehouse";

export const INVOICE_LEDGER = "Invoice Ledger";

// Every report in the app, as the Reports tab shows them: one box each,
// grouped. A report with a `path` is its own page and keeps the URL it always
// had, so bookmarks and links into it (the Buyers list's ledger icon) still
// work. One with a `modal` opens over the Reports tab.
export const REPORT_GROUPS = [
  {
    title: "Ledgers",
    reports: [
      {
        title: "Product Ledger",
        description: "Every movement of a product over a period",
        path: "/main/stock-ledger",
        icon: <Inventory2Icon fontSize="small" />,
      },
      {
        title: "Buyer Ledger",
        description: "Every invoice billed to a buyer, with tax, 236G and 236H",
        path: "/main/buyer-ledger",
        icon: <FaceIcon fontSize="small" />,
      },
    ],
  },
  {
    title: "Invoices",
    reports: [
      {
        title: "Invoice Summary",
        description: "Invoice totals of a company over a period",
        path: "/main/view-invoice-summary",
        icon: <SummarizeIcon fontSize="small" />,
      },
      {
        title: "Invoice Ledger",
        description: "Every invoice of a company over a period, as PDF or Excel",
        modal: INVOICE_LEDGER,
        icon: <ReceiptLongIcon fontSize="small" />,
      },
    ],
  },
  {
    title: "General Reports",
    reports: [
      {
        title: "Stock Report",
        description: "Each item's quantity on hand, and how healthy it is",
        path: "/main/stock-report",
        icon: <WarehouseIcon fontSize="small" />,
      },
    ],
  },
];

// The pages the Reports tab opens: the menu keeps "Reports" highlighted while
// one of them is shown.
export const REPORT_PATHS = REPORT_GROUPS.flatMap((group) => group.reports)
  .map((report) => report.path)
  .filter(Boolean);
